import React from 'react';
import { translations } from '../data/translations';
import { ArrowRight } from 'lucide-react';

const HeroSection = ({ lang }) => {
  const t = translations[lang].hero;
  
  return (
    <section className="min-h-screen bg-black flex items-center justify-center relative overflow-hidden">
      {/* Subtle grid pattern overlay */}
      <div 
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `
            repeating-linear-gradient(0deg, transparent, transparent 1px, transparent 1px, transparent 80px),
            repeating-linear-gradient(-90deg, #fff, #fff 1px, transparent 1px, transparent 80px)
          `,
          backgroundSize: '100% 100%'
        }}
      />
      
      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-16 text-center pt-20">
        {/* Main Headline */}
        <h1 className="text-4xl md:text-5xl lg:text-[66px] font-semibold text-white leading-[1.1] tracking-[-0.62px] mb-8">
          {t.headline}
        </h1>
        
        {/* Subheadline */}
        <p className="text-lg md:text-xl text-white/85 font-normal leading-relaxed max-w-3xl mx-auto mb-12">
          {t.subheadline}
        </p>
        
        {/* CTA Button */}
        <a
          href="#portfolio"
          className="inline-flex items-center justify-between gap-3 bg-[#00FFD1] text-black px-8 py-4 text-lg font-medium hover:bg-[#00FFD1]/10 hover:text-[#00FFD1] transition-all duration-400 ease-in-out group"
        >
          {t.cta}
          <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
        </a>
      </div>
      
      {/* Bottom gradient fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-black to-transparent" />
    </section>
  );
};

export default HeroSection;
